import React from 'react'
import {AttributeModel} from '../model/AttributeModel'


export const SimpleAttribute = ({attribute}: { attribute: AttributeModel }) => {
    return <span className="item-attribute-value" data-testid="test-details-simple-attribute-value" key={attribute.id}>{attribute?.value?.value} {attribute.unit}</span>
}
